"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { capture } from "@/lib/analytics/events";

/**
 * A plain link to /post-a-job, instrumented with `post_a_job_link_click`.
 *
 * EmployerCta and OrgClaimBanner already track their own CTAs
 * (`employer_cta_clicked`, `org_claim_cta_click`), but every other link to
 * this page — header nav, footer, the jobs-board banner, both alternatives
 * pages, suggest-a-role — was a plain `<Link>` with no event. That's most of
 * the gap between 46 pageviews and 19 tracked clicks on /post-a-job over 30
 * days: the untracked links, not a mystery referrer.
 */
export function PostAJobLink({
  placement,
  className,
  children,
}: {
  placement:
    | "header"
    | "footer"
    | "jobs_page"
    | "alternatives_index"
    | "alternatives_detail"
    | "suggest_a_role";
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      href="/post-a-job"
      className={className}
      onClick={() => capture("post_a_job_link_click", { placement })}
    >
      {children}
    </Link>
  );
}
